"use client";

import * as React from "react";

import { useInstagramMedia, type UseInstagramMediaOptions } from "@/hooks/instagramMedia";
import type { FetchApiError } from "@/lib/strapi";
import type { InstagramMediaPost } from "@/services/instagramMedia";

export type InstagramMediaStoreValue = {
  posts: InstagramMediaPost[];
  data: unknown;
  error: FetchApiError | null;
  isLoading: boolean;
  refetch: () => void;
};

const InstagramMediaStoreContext = React.createContext<InstagramMediaStoreValue | null>(null);

export function InstagramMediaProvider({
  children,
  initialData,
  ...options
}: React.PropsWithChildren<UseInstagramMediaOptions & { initialData?: unknown | null }>): React.JSX.Element {
  const state = useInstagramMedia({ ...options, initialData });

  const value: InstagramMediaStoreValue = {
    posts: state.posts,
    data: state.data,
    error: state.error,
    isLoading: state.isLoading,
    refetch: state.refetch,
  };

  return <InstagramMediaStoreContext.Provider value={value}>{children}</InstagramMediaStoreContext.Provider>;
}

export function useInstagramMediaStore(): InstagramMediaStoreValue {
  const value = React.useContext(InstagramMediaStoreContext);
  if (!value) {
    throw new Error("useInstagramMediaStore must be used within InstagramMediaProvider");
  }
  return value;
}
